<template>
  <div class="bio_more_data_popup">
    <div class="bio_more_data_popup_center">
      <div class="bio_more_data_popup_modal">
        <span class="bio_popup_close"
          ><i
            class="fa fa-times-circle-o"
            aria-hidden="true"
            @click="hideBioDataPopup"
          ></i
        ></span>
        <div class="bio_more_data_popup_body" v-html="bio"></div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';
export default {
  name: "bio-full-popup",
  props: ['bio'],
  methods: {
    hideBioDataPopup() {
      bus.$emit('bioFullDataPopupBus', false)
      document.body.classList.remove("body_right_scroll_remove");
    },
  },
};
</script>

<style lang="scss">
.bio_more_data_popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.92);
  display: table;
  width: 100%;
  height: 100%;
  font-family: "MyriadProRegular", "Lato", sans-serif;
  .bio_more_data_popup_center {
    display: table-cell;
    vertical-align: middle;
  }
  .bio_more_data_popup_modal {
    background: #000;
    max-width: 800px;
    margin: 0 auto;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    position: relative;
    padding: 1px;
  }
  .bio_popup_close {
    position: absolute;
    top: 5px;
    right: 5px;
    line-height: 1;
    .fa {
      font-size: 22px;
      color: #e4002b;
      cursor: pointer;
      transform: scale(1);
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -webkit-transition: all ease 0.5s;
      transition: all ease 0.5s;
      &:hover {
        color: #87cefa;
      }
    }
  }
  .bio_more_data_popup_header {
    padding: 10px 15px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    h4 {
      font-size: 24px;
      letter-spacing: 0;
      margin-bottom: 0;
      color: #ffd400;
    }
  }
  .bio_more_data_popup_body {
    padding: 25px;
    h3 {
      font-size: 24px;
      margin-bottom: 6px;
      line-height: 1;
      color: #fffcc4;
    }
    p {
      font-size: 18px;
      line-height: 1.3;
      color: #d6d6d6;
      text-align: justify;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue,
        Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,
        Noto Color emoji;
    }
  }
}
</style>